/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-06-17 16:08:20
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2025-07-29 13:53:42
 * @FilePath: \crane-safety-manager\src\Layouts\Footer.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Footer } from 'antd/es/layout/layout';
import React from 'react';
import { styled } from 'styled-components';
import { Row } from 'antd';

import usecustomStyles from '../Common/customStyles';
import { themecolor } from '../config';
import { border } from 'polished';
import {longImagePath} from '../assets/images/logo-sichuan';

const customStyles = usecustomStyles();

const StyleFooter = styled(Footer)`
    padding-inline: 24px;
    z-index: 9;
    color: ${customStyles.colorTextDisabled};
    margin-left: ${themecolor.components.Menu.verticalSidebarWidth}px;
    background-color: ${({ theme }) => theme.token.colorBgContainer};
    border-top: 1px solid;
    border-color: ${({ theme }) => theme.token.colorBorder};

    @media screen and (max-width: 768px) {
        margin-left: 0;
    }
`;

const FooterLayout = () => {
    return (
        <StyleFooter id="antFooterLayout">
            <Row align="middle">
                <div style={{ fontSize:'14px',color:'#616161',display: 'flex', justifyContent: 'flex-end', alignItems:'flex-end',width: '100%', whiteSpace: 'nowrap', zIndex: '9' }}>
                    <img style={{border:0}} src={longImagePath} alt=''/>
                    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11040102700068" style={{ marginRight: '16px', marginBottom: '0', textDecoration:'none',color:'inherit' }}>川公网安备51010702043115号</a>
                    <a href="http://beian.miit.gov.cn/" style={{ marginRight: '16px', marginBottom: '0', textDecoration:'none',color:'inherit' }}>蜀ICP备2024085151</a>
                    <p style={{ marginRight: '16px', marginBottom: '0' }}>2024 © 四川世融数建科技有限责任公司 </p>
                </div>
            </Row>
        </StyleFooter>
    );
};

export default FooterLayout;
